import { Component, Input } from '@angular/core';

@Component(
	{ selector: 'info-tip-label'
	, template:  '<ng-container *infoTip="label; showIcon: true"></ng-container>'
	}
)
export class InfoTipLabelComponent {
	@Input()
	public readonly label: string;
}
